import React from 'react'
import ClassNames from 'classnames'
import { default as VARIABLES } from '../../themes/styles/variables'

import Switch from 'react-switch'
//https://www.npmjs.com/package/react-switch

import { SwicthStyle } from './styled'

export class Switcher extends React.PureComponent {
  render() {
    const {
      className, //
    } = this.props
    return (
      <SwicthStyle className={ClassNames('switch-wrapper', className)}>
        <Switch
          onChange={() => {}}
          checked={false}
          uncheckedIcon={false}
          checkedIcon={false}
          handleDiameter={8}
          height={16}
          width={27}
          offColor={VARIABLES.COLORS.GRAY_5}
          onColor={VARIABLES.COLORS.GREEN_3}
          {...this.props}
        />
      </SwicthStyle>
    )
  }
}
